/**
 *
 * Asynchronously loads the component for BusinessCompliancePage
 *
 */
import { lazyLoad } from "utils";

export const BusinessesPageLazy = lazyLoad(
  () => import("./businesses"),
  (module) => module.BusinessesPage
);

export const BusinessDetailsMainPageLazy = lazyLoad(
  () => import("./business-details"),
  (module) => module.BusinessDetailsMainPage
);

export const BusinessTransactionLimitsPageLazy = lazyLoad(
  () => import("./business-details/transaction-limits"),
  (module) => module.TransactionLimitsPage
);

export const BusinessDetailsAccountTransactionsPageLazy = lazyLoad(
  () => import("./business-details/account-transactions"),
  (module) => module.BusinessDetailsAccountTransactions
);

export const AddNewBusinessPageLazy = lazyLoad(
  () => import("./add-new-business"),
  (module) => module.AddNewBusiness
);

export const ContinueBusinessRegistrationPageLazy = lazyLoad(
  () => import("./continue-business-registration"),
  (module) => module.ContinueBusinessRegistration
);

export const UpdateBusinessTypePageLazy = lazyLoad(
  () => import("./update-business-type"),
  (module) => module.UpdateBusinessType
);
